import {
  List,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
  SelectInput,
  FilterButton,
  TopToolbar,
  ExportButton,
  DateInput,
} from 'react-admin';
import { ActionChip } from '../../components/settings/ActionChip';

interface AuditLog {
  id: number;
  admin_user_id: number;
  admin_username?: string;
  admin_email?: string;
  action: string;
  resource_type: string;
  resource_id?: number;
  changes?: Record<string, any>;
  ip_address?: string;
  created_at: string;
}

const auditLogFilters = [
  <SelectInput
    key="admin_user_id"
    source="admin_user_id"
    label="Admin User"
    choices={[]}
    alwaysOn
  />,
  <SelectInput
    key="action"
    source="action"
    label="Action"
    choices={[
      { id: 'create', name: 'Create' },
      { id: 'update', name: 'Update' },
      { id: 'delete', name: 'Delete' },
      { id: 'view', name: 'View' },
    ]}
  />,
  <SelectInput
    key="resource_type"
    source="resource_type"
    label="Resource Type"
    choices={[
      { id: 'users', name: 'Users' },
      { id: 'events', name: 'Events' },
      { id: 'admin_users', name: 'Admin Users' },
      { id: 'roles', name: 'Roles' },
      { id: 'settings', name: 'Settings' },
    ]}
  />,
  <DateInput key="date_from" source="created_at_gte" label="From Date" />,
  <DateInput key="date_to" source="created_at_lte" label="To Date" />,
];

const AuditLogListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

export const AuditLogList = () => (
  <List
    filters={auditLogFilters}
    actions={<AuditLogListActions />}
    perPage={50}
    sort={{ field: 'created_at', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="admin_username" label="Admin" />
      <FunctionField
        source="action"
        label="Action"
        render={(record: AuditLog) => <ActionChip action={record.action} />}
      />
      <TextField source="resource_type" label="Resource Type" />
      <TextField source="resource_id" label="Resource ID" />
      <TextField source="ip_address" label="IP Address" />
      <DateField source="created_at" showTime label="Time" />
    </Datagrid>
  </List>
);
